<template>
    <v-container>
      <activation-blocker />
        <v-layout wrap>
            <v-flex xs12>
                <w-main-title
                        :title="'Hola ' + ((currentUser && currentUser.first_name) || '') + '!' "
                        :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12 >
            <provider-on-boarding />
          </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import WMainTitle from '@/components/common/WMainTitle'
    import ProviderOnBoarding from '@/components/dashboard/ProviderOnBoarding'

    import {dashboardComponentName} from '@/utils/Account'
    import {mapState} from 'vuex'
    import ActivationBlocker from "@/components/account/ActivationBlocker";

    export default {
        components: {
          ActivationBlocker,
          WMainTitle,
          ProviderOnBoarding,
        },
        data() {
            return {
                breadcrumbs: [
                    {
                        text: 'Configuración Inicial',
                        disabled: true,
                        to: ''
                    }
                ],
            }
        },

        computed: {
        ...mapState(['currentUser', 'currentProvider']),
          dashboardComponentName
      }
    }
</script>

<style scoped>
    a{
        text-decoration: none;
    }

    >>>.v-parallax__content{
        background-color: rgba(82, 82, 82, 0.89) !important
    }
</style>